import styled from "styled-components";

export const StyledDevelopmentChart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100dvh;

  & .chart-body {
    flex: 1;
    min-height: 0;
    position: relative;
  }

  & .chart-loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 300px;
  }

  & svg:focus,
  & svg:focus-visible,
  & .recharts-wrapper:focus,
  & .recharts-wrapper *:focus {
    outline: none;
  }

  & svg:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.purple_2};
    outline-offset: 2px;
  }
`;

export const StyledLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 30px;
  margin-top: 30px;
`;

export const LegendItem = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const LegendDot = styled.span<{ $color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  display: inline-block;
`;
